import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

import { SlickCarouselModule } from 'ngx-slick-carousel';


import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from "../shared/shared.module";

@NgModule({
    declarations: [HomeComponent],
    imports: [
        CommonModule,
        HomeRoutingModule,
        NgSelectModule,
        FormsModule,
        GooglePlaceModule,
        SlickCarouselModule,
        // MatTooltipModule,
        // NgxStarRatingModule,
        SharedModule
    ]
})
export class HomeModule {}
